<template>
  <div class="manage-report">
    <el-card
v-loading="loading"
class="card-container"
shadow="never">
      <div
slot="header"
class="clearfix">
        <h3 class="my-0">Tổng quan báo cáo</h3>
      </div>
      <el-row
:gutter="36"
class="my-m">
        <el-col :span="8">
          <el-row
type="flex"
justify="space-between"
class="mb-m pr-l">
            Số lượng hiện vật: <strong>10</strong>
          </el-row>
          <el-row
type="flex"
justify="space-between"
class="mb-m pr-l">
            Số lượng nhân vật: <strong>10</strong>
          </el-row>
          <el-row
type="flex"
justify="space-between"
class="mb-m pr-l">
            Số lượng tài liệu: <strong>10</strong>
          </el-row>
          <el-row
type="flex"
justify="space-between"
class="mb-m pr-l">
            Số lượng phim: <strong>10</strong>
          </el-row>
          <el-row
type="flex"
justify="space-between"
class="mb-m pr-l">
            Số lượng ảnh: <strong>10</strong>
          </el-row>
          <el-row
type="flex"
justify="space-between"
class="mb-m pr-l">
            Số lượng băng đĩa: <strong>10</strong>
          </el-row>
        </el-col>
        <el-col :span="8">
          <el-row
type="flex"
justify="space-between"
class="mb-m pr-l">
            Phê duyệt kho chính thức: <strong>10</strong>
          </el-row>
          <el-row
type="flex"
justify="space-between"
class="mb-m pr-l">
            Bổ sung thông tin: <strong>10</strong>
          </el-row>
          <el-row
type="flex"
justify="space-between"
class="mb-m pr-l">
            Trả lại: <strong>10</strong>
          </el-row>
          <el-row
type="flex"
justify="space-between"
class="mb-m pr-l">
            Chờ duyệt: <strong>10</strong>
          </el-row>
        </el-col>
        <el-col :span="8">
          <el-row
type="flex"
justify="space-between"
class="mb-m pr-l">
            Số lượng Triển lãm online: <strong>10</strong>
          </el-row>
          <el-row
type="flex"
justify="space-between"
class="mb-m pr-l">
            SL Triển lãm online sắp triển lãm: <strong>10</strong>
          </el-row>
          <el-row
type="flex"
justify="space-between"
class="mb-m pr-l">
            SL Triển lãm online đang triển lãm: <strong>10</strong>
          </el-row>
          <el-row
type="flex"
justify="space-between"
class="mb-m pr-l">
            SL Triển lãm online đã kết thúc: <strong>10</strong>
          </el-row>
        </el-col>
      </el-row>
    </el-card>
    <el-card
v-loading="loading"
class="card-container mt-5xl"
shadow="never">
      <div
slot="header"
class="clearfix">
        <h3 class="my-0">Chi tiết báo cáo</h3>
      </div>
      <el-tabs type="border-card">
        <el-tab-pane label="Hộ chiếu hiện vật">Hộ chiếu hiện vật</el-tab-pane>
        <el-tab-pane label="Hộ chiếu nhân vật">Hộ chiếu nhân vật</el-tab-pane>
        <el-tab-pane label="Báo cáo phim">Báo cáo phim</el-tab-pane>
        <el-tab-pane label="Báo cáo ảnh">Báo cáo ảnh</el-tab-pane>
        <el-tab-pane label="Báo cáo văn bản">Báo cáo văn bản</el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>

<script>
export default {
  name: "ManageReport",
  data() {
    return {
      loading: false,
    };
  },
};
</script>

<style lang="scss" scoped></style>
